module.exports = __webpack_public_path__ + "static/img/wait.62ea4777.png";